import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

import { useGetAssociation } from 'legacy/groups/hooks';
import { requestJoinAssociation } from 'legacy/search/hooks';
import { useMediaQuery } from 'theme/useMediaQuery';
import { Breakpoints, BreakpointsKeys } from 'theme/types';

function useViewAssociation() {
  const router = useRouter();
  const [isEmailDomainModalVisible, setIsEmailDomainModalVisible] =
    useState(false);
  const { mutate: requestJoinAssociationCommand } = requestJoinAssociation();

  // TODO: Manage screen sizes from within a shared hook inside the design system
  const isDesktop = useMediaQuery(
    `(min-width: ${Breakpoints[BreakpointsKeys.Tablet]}px)`
  );

  const {
    data: association,
    refetch,
    isLoading,
    isError
  } = useGetAssociation({
    associationId: router.query.associationId as string
  });

  useEffect(() => {
    if (router.query.join === 'true' && association?.id) {
      const newQuery = { ...router.query };
      delete newQuery.join;
      router.replace(
        {
          pathname: router.pathname,
          query: newQuery
        },
        undefined,
        { shallow: true }
      );

      if (association.requiredEmailDomains.length > 0) {
        setIsEmailDomainModalVisible(true);
      } else {
        joinAssociation();
      }
    }
  }, [router.query.join, association?.id]);

  const handleJoinAssociation = () => {
    if (shouldShowScreeningQuestions) {
      const query = router.query.webview
        ? { webview: router.query.webview }
        : {};
      router.push({
        pathname: `/associations/${router.query.associationId}/join/screening`,
        query
      });
    } else if (association.requiredEmailDomains.length > 0) {
      setIsEmailDomainModalVisible(true);
    } else {
      joinAssociation();
    }
  };

  const joinAssociation = () => {
    requestJoinAssociationCommand(
      { associationId: association.id },
      {
        onSuccess: () => {
          refetch();
        }
      }
    );
  };

  const shouldShowScreeningQuestions =
    association?.requestScreeningQuestions === true &&
    !!association?.screeningQuestionsFormId;

  const closeEmailDomainModal = () => {
    setIsEmailDomainModalVisible(false);
  };

  const isJoinBlocked = association?.blockAssociationMemberJoin === true;

  return {
    data: {
      association,
      isLoading,
      isError,
      isDesktop,
      isEmailDomainModalVisible,
      shouldShowScreeningQuestions,
      isJoinBlocked
    },
    joinAssociation: handleJoinAssociation,
    closeEmailDomainModal
  };
}

export default useViewAssociation;
